import { deltaTone, formatDelta, formatNumber } from "./util";

interface SceneLensDiffEntry {
  before_match_pct?: number;
  after_match_pct?: number;
  delta_match_pct?: number;
}

interface SceneLensFlatEntry {
  match_pct?: number;
  score_abs?: number;
}

const SCENE_LABELS: Record<string, string> = {
  nordschleife: "纽北",
  suzuka: "铃鹿",
  tianma: "天马",
  tsukuba: "筑波",
  mountain_road: "山路",
  city_dense: "拥堵城市",
  city_suburban: "城郊",
  highway_long: "高速长途",
  canyon: "峡谷",
};

export function ScenesPanel({ payload }: { payload: unknown }) {
  const scenes = (payload as { scene_lens?: Record<string, unknown> })?.scene_lens ?? {};
  const entries = Object.entries(scenes);
  if (entries.length === 0) {
    return <p className="muted small">没有场景数据。</p>;
  }
  const isDiff = entries.some(
    ([, v]) =>
      v && typeof v === "object" && "after_match_pct" in (v as object),
  );

  return (
    <table className="canvas-table scenes-table">
      <thead>
        <tr>
          <th>场景</th>
          {isDiff ? (
            <>
              <th>改装前</th>
              <th>改装后</th>
              <th>变化</th>
            </>
          ) : (
            <>
              <th>匹配度</th>
              <th>评分</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {entries.map(([sceneId, raw]) => {
          const label = SCENE_LABELS[sceneId] ?? sceneId;
          if (isDiff) {
            const v = raw as SceneLensDiffEntry;
            const tone = deltaTone(v.delta_match_pct);
            return (
              <tr key={sceneId}>
                <td>{label}</td>
                <td>{formatNumber(v.before_match_pct, 1)}</td>
                <td>{formatNumber(v.after_match_pct, 1)}</td>
                <td className={`tone-${tone}`}>{formatDelta(v.delta_match_pct, 1)}</td>
              </tr>
            );
          }
          const v = raw as SceneLensFlatEntry;
          return (
            <tr key={sceneId}>
              <td>{label}</td>
              <td>{formatNumber(v.match_pct, 1)}</td>
              <td>{formatNumber(v.score_abs, 2)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
